import apiService from '~/utils/plugins/apiService.js';

export default defineNuxtPlugin(nuxtApp => {
    nuxtApp.provide('api', apiService());
});
